import { XCircle } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@/components/ui/card"
import type { IntakeLoad } from "@/features/intake/api/types"

interface RefusedCardProps {
  load: IntakeLoad
}

export function RefusedCard({ load }: RefusedCardProps) {
  const { t } = useTranslation("intake")

  return (
    <Card>
      <CardContent className="space-y-3">
        <div className="flex items-start gap-3">
          <div className="bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300 flex size-9 items-center justify-center rounded-md">
            <XCircle className="size-5" />
          </div>
          <div className="space-y-1">
            <h2 className="text-lg font-semibold">
              {t("completed.rejectedTitle")}
            </h2>
            <p className="text-muted-foreground text-sm">
              {t("completed.rejectedSubtitle")}
            </p>
          </div>
        </div>
        {load.rejectionReason ? (
          <div className="bg-muted/30 rounded-md border p-3">
            <div className="text-muted-foreground text-[10px] uppercase tracking-wide">
              {t("completed.rejectionReason")}
            </div>
            <p className="text-sm">{load.rejectionReason}</p>
          </div>
        ) : null}
      </CardContent>
    </Card>
  )
}
